// src/pages/AddCustomer.js

import React, { useContext, useState } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import {
  Typography,
  Paper,
  Button,
  Grid,
  Box,
  CircularProgress,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { addCustomer } from '../services/customerService';
import customerSchema from '../models/customerSchema';
import DynamicForm from '../components/DynamicForm';
import { OrgContext } from '../contexts/OrgContext'; // Add this
import BackButton from '../components/BackButton';

const AddCustomer = () => {
  const { orgId } = useContext(OrgContext); // Add this
  const methods = useForm();
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const onSubmit = (data) => {
    setLoading(true);
    // Move whatsapp_number to meta
    const { whatsapp_number, ...rest } = data;
    const payload = {
      ...rest,
      meta: { ...(data.meta || {}), whatsapp_number: whatsapp_number || undefined }
    };
    addCustomer(orgId, payload)
      .then(() => navigate(`/${orgId}/customers`))
      .catch((error) => {
        console.error('Error adding customer:', error);
        // Handle error
      })
      .finally(() => setLoading(false));
  };

  return (
    <Paper
      sx={{
        p: 3,
        maxWidth: 900,
        mx: 'auto',
        backgroundColor: '#1e1e1e',
        color: 'text.primary',
      }}
    >
      <BackButton />
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Typography variant="h5" gutterBottom>
            Add Customer
          </Typography>
          <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(onSubmit)} autoComplete="off">
              <DynamicForm schema={customerSchema} control={methods.control} errors={methods.formState.errors} />
              <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid item xs={12} textAlign="right">
                  <Button type="submit" variant="contained" color="primary">
                    Add Customer
                  </Button>
                </Grid>
              </Grid>
            </form>
          </FormProvider>
        </>
      )}
    </Paper>
  );
};

export default AddCustomer;
